import FileDragAndDrop from 'file-manager-components/components/FileUpload/FileDragAndDrop';
export default FileDragAndDrop;